/* eslint-disable */
import reducerConstant from 'common/reducerConstants';

const initialState = {
  loginStatus: false,
  errorMessage: {
    email: null,
    password: null,
  },
  message: null,
  loginTimeStamp: null,
  forgotPasswordStatus: false,
  forgotErrorMessage: null,
  forgotTimeStamp: null,
  verifiedEmail: false,
  verifyError: null,
  verifyTs: null,
};

const loginReducer = (state = initialState, action) => {
  switch (action.type) {
    case reducerConstant.loginSuccess:
      return {
        ...state,
        loginStatus: true,
        errorMessage: {
          email: null,
          password: null,
        },
        message: null,
        loginTimeStamp: Date.now(),
      };
    case reducerConstant.loginFailed:
      const loginObj = {
        email:
          (action.payload.errors &&
            action.payload.errors.email &&
            action.payload.errors.email[0]) ||
          null,
        password:
          (action.payload.errors &&
            action.payload.errors.password &&
            action.payload.errors.password[0]) ||
          null,
      };
      return {
        ...state,
        loginStatus: false,
        errorMessage: loginObj,
        message: action.payload.message,
        loginTimeStamp: Date.now(),
      };
    case reducerConstant.forgotSuccess:
      return {
        ...state,
        errorMessage: '',
        forgotPasswordStatus: true,
        forgotErrorMessage: null,
        forgotTimeStamp: Date.now(),
      };
    case reducerConstant.forgotFailed:
      const forgotObj = {
        email:
          (action.payload.errors &&
            action.payload.errors.email &&
            action.payload.errors.email[0]) ||
          null,
        password:
          (action.payload.errors &&
            action.payload.errors.password &&
            action.payload.errors.password[0]) ||
          null,
      };
      return {
        ...state,
        errorMessage: forgotObj,
        forgotPasswordStatus: false,
        forgotErrorMessage: action.payload.message,
        forgotTimeStamp: Date.now(),
      };
    case reducerConstant.resetLoginState:
      return {
        loginStatus: false,
        errorMessage: {
          email: null,
          password: null,
        },
        message: null,
        loginTimeStamp: null,
        forgotPasswordStatus: false,
        forgotErrorMessage: null,
      };
    case reducerConstant.verifyEmailSuccess:
      return {
        ...state,
        verifiedEmail: true,
        verifyError: null,
        verifyTs: Date.now(),
      };
    case reducerConstant.verifyEmailFailed:
      const verifyObj = {
        id:
          (action.payload.errors &&
            action.payload.errors.id &&
            action.payload.errors.id[0]) ||
          null,
      };
      return {
        ...state,
        verifiedEmail: false,
        verifyError: verifyObj,
        verifyTs: Date.now(),
      };
    default:
      return state;
  }
};
export default loginReducer;
